var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgEnquiries = function SvgEnquiries(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1137_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.24935 19.2836C8.78068 19.2836 10.8327 17.2316 10.8327 14.7003C10.8327 12.1689 8.78068 10.1169 6.24935 10.1169C3.71804 10.1169 1.66602 12.1689 1.66602 14.7003C1.66602 15.5351 1.88921 16.3178 2.27918 16.9919L1.89518 19.0544L3.95768 18.6704C4.63183 19.0604 5.41452 19.2836 6.24935 19.2836Z",
    stroke: "#8A9FC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7352 15.8651C13.5488 15.734 14.313 15.4557 14.9999 15.0584L17.9999 15.6169L17.4413 12.6169C18.0085 11.6364 18.3332 10.4979 18.3332 9.28361C18.3332 5.60171 15.3484 2.61694 11.6665 2.61694C8.31037 2.61694 5.53345 5.09693 5.06836 8.32431",
    stroke: "#8A9FC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1137_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.950195)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnquiries, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Enquiries.5dee5108.svg";
export { ForwardRef as ReactComponent };